<div class="form-holder">
  <h1>Redigera din profil</h1>
  <mat-form-field>
    <mat-label>Namn</mat-label>
    <input matInput [formField]="form.name">

    @for (error of form.name().errors(); track $index) {
      <mat-error>{{ error.message }}</mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>Epost</mat-label>
    <input matInput [formField]="form.email">

    @for (error of form.email().errors(); track $index) {
      <mat-error>{{ error.message }}</mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>Telefon</mat-label>
    <input matInput [formField]="form.phone">
  </mat-form-field>

  <mat-form-field>
    <mat-label>Facebook</mat-label>
    <input matInput [formField]="form.facebook">
  </mat-form-field>

  <mat-form-field>
    <mat-label>Instagram</mat-label>
    <input matInput [formField]="form.instagram">
  </mat-form-field>

  <mat-form-field>
    <mat-label>LinkedIn</mat-label>
    <input matInput [formField]="form.linkedIn">
  </mat-form-field>

  <mat-form-field>
    <mat-label>Unsplash</mat-label>
    <input
      matInput
      [formField]="form.unsplash"
      placeholder="Ex. https://www.instagram.com/natgeo/"
    >
  </mat-form-field>

  <mat-form-field>
    <mat-label>Hemsida</mat-label>
    <input
      matInput
      [formField]="form.web"
      placeholder="Ex. https://www.minsida.se/"
    >
  </mat-form-field>

  <mat-form-field>
    <mat-label>Tackmeddelande</mat-label>
    <textarea
      rows="5"
      matInput
      [formField]="form.thankYouMessage"
      placeholder="Ex. Stort tack för samtycket och medverkan i mina bilder!{{'\n\n'}}Vänligen{{'\n'}}{{form.name().value()}}"
    ></textarea>
  </mat-form-field>

  <mat-divider/>

  <h3>Profilbild</h3>

  <img src="crazy-cat.jpg" class="circular-image" alt="User profile">

  <div class="button-holder">
    <button (click)="startCamera()" matButton="filled"><mat-icon>photo_camera</mat-icon>Ta bild</button>
    <button matButton="filled"><mat-icon>image</mat-icon>Ladda upp</button>
  </div>
  <mat-divider/>

  <div class="button-holder">
    <button [disabled]="form().invalid()" matButton="filled">
      <mat-icon>save</mat-icon>
      Spara
    </button>
  </div>
</div>
